import { API_METHOD } from "types/common";
import { ScheduledEvent } from "types/eventManagement/EventManagementInterface";

type USERLOADResponse = {
  unsubscribed: number;
  complaint: number;
  active: number;
  bounced: number;
  segmentId: number;
  countId: number;
};

/*==============================================================================
                                 A P I S
==============================================================================*/

export class EVLoadManagementAPIEndpoints {
  static GET_LOAD = (pilotId: string) =>
    `/v2.0/campaign/subscriber-data`;
}

export namespace GetUserLoadAPI {
  export const method: API_METHOD = "GET";

  export const apiEndpoint = EVLoadManagementAPIEndpoints.GET_LOAD;

  export type retval = USERLOADResponse;

  export type params = { 
    pilotId : Number
    campaignType : ScheduledEvent.EventType 
  }
  
}
